import { Paragraph, unit, DropdownMenu, makeForm } from '@aubade/core/ui-kit'
import { useConnectedUser } from '@aubade/domain/adapters'
import { isAdmin, isSociety } from '@aubade/domain/components'
import { Box, HStack, VStack } from '@chakra-ui/react'
import { type BaseSyntheticEvent } from 'react'

import { AgencyFilter, SocietyAgencyFilter } from '../../../components'
import { ActiveFilters } from '../../Publications/Components/ActiveFliters'
import type { StatisticsFiltersType } from '../Filters'

const { Input, useWatch } = makeForm<
  StatisticsFiltersType,
  'date' | 'displayType'
>()

type Props = {
  filterState: StatisticsFiltersType
  onChange: (
    e?: BaseSyntheticEvent<object, any, any> | undefined,
  ) => Promise<void>
}

export function FiltersSection(props: Props) {
  const { filterState, onChange } = props
  const name = useGetName(filterState)

  const { role } = useConnectedUser()

  return (
    <VStack
      width="full"
      gap={unit('20')}
      alignItems={'flex-start'}
      marginY={unit('30')}
    >
      <Paragraph
        size="lg"
        fontWeight="bold"
        text="statistics.filters.global.title"
      />

      <HStack gap={unit('15')} width="full" justifyContent={'flex-start'}>
        <DropdownMenu title={name} variant="rounded">
          {isSociety(role) ? (
            <AgencyFilter onFilterChange={onChange} single />
          ) : (
            <SocietyAgencyFilter onFilterChange={onChange} single />
          )}
        </DropdownMenu>
        <DateRangeFilter onFilterChange={onChange} />
      </HStack>
      <ActiveFilters onChange={onChange} variant="negative" />
    </VStack>
  )
}

function useGetName(filterState: StatisticsFiltersType) {
  const { societies, agencies } = filterState

  const { role } = useConnectedUser()

  if (isAdmin(role)) {
    if (societies?.length) {
      return 'filters.statistics.society'
    }
    if (agencies?.length) {
      return 'filters.statistics.agency'
    }
    return 'filters.statistics.national'
  }
  if (isSociety(role)) {
    if (agencies?.length) {
      return 'filters.statistics.agency'
    }
    return 'filters.statistics.society'
  }

  return ''
}

type DateRangeProps = {
  onFilterChange: (
    e?: BaseSyntheticEvent<object, any, any> | undefined,
  ) => Promise<void>
}

function DateRangeFilter(props: DateRangeProps) {
  const { onFilterChange } = props
  const [date] = useWatch(['date'])
  return (
    <HStack width="full" gap={unit('15')}>
      <Paragraph text={'filters.date.from'} />
      <Box width={unit('170')}>
        <Input.Date
          variant="rounded"
          name="date.startDate"
          label=" "
          onChange={() => onFilterChange()}
          max={date?.endDate}
        />
      </Box>
      <Paragraph text={'filters.date.to'} />
      <Box width={unit('170')}>
        <Input.Date
          variant="rounded"
          name="date.endDate"
          min={date?.startDate}
          label=" "
          onChange={() => onFilterChange()}
        />
      </Box>
    </HStack>
  )
}
